import templateUrl from 'emun.invoice/invoice-details-header.htm'
import InvoiceOneUpController from 'emun.invoice/invoice-one-up.controller'

export default {
    bindings: {
        invoice: '<'
    },
    controller: InvoiceOneUpController,
    templateUrl($element, $attrs) {
        return $attrs.templateUrl || templateUrl
    }
};
